import { type FC } from 'react'
import { useIntl } from 'react-intl'

import { type ErrorComponentProps } from '@tanstack/react-router'

import { ErrorTemplate } from '@/components/templates/Error/ErrorTemplate'

export const RouterErrorPage: FC<ErrorComponentProps> = ({ reset }) => {
  const intl = useIntl()

  return <ErrorTemplate title={intl.formatMessage({ id: 'errors.generic.title' })} onClick={reset} />
}
